/**
 * 기사구분 화면 표기(2026-10-15 way 「모든 표기는 관리기사A, 관리기사B 로 통일」).
 * DB 값(버스인 원문 `직영기사`·`차주소유기사`)은 그대로 두고 **보이는 글자만** 바꾼다 —
 * 정산 판정(`like '직영%'`)·이관이 원문에 묶여 있다. 직영사업장기사는 어느 쪽도 아니라 원문 그대로.
 */
export const KIND_A = '직영기사';
export const KIND_B = '차주소유기사';

export function kindLabel(k: unknown): string {
  const s = k === null || k === undefined ? '' : String(k);
  return s === KIND_A ? '관리기사A' : s === KIND_B ? '관리기사B' : s;
}

/** 검색어 안의 「관리기사A/B」를 원문으로(서버는 원문으로 찾는다). */
export function kindSearch(s: string): string {
  return s.replace(/관리기사\s*a/gi, KIND_A).replace(/관리기사\s*b/gi, KIND_B);
}
